const READY = 'ready'
const CHANGE = 'change'

export function dataSource (state = {}, action) {
  switch (action.type) {
    case READY:
    case CHANGE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export function ready (data) {
  return { type: READY, payload: data }
}

export function change (data) {
  return { type: CHANGE, payload: data }
}
